import { render, staticRenderFns } from "./TaskListList.component.vue?vue&type=template&id=2fd2d90a&scoped=true&"
import script from "./TaskListList.component.vue?vue&type=script&lang=js&"
export * from "./TaskListList.component.vue?vue&type=script&lang=js&"
import style0 from "./TaskListList.component.vue?vue&type=style&index=0&id=2fd2d90a&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd2d90a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VDivider,VList})
